(function () {
  "use strict";

  var GLOBAL_KEY = "EVPProductAvailability";
  var TIME_ZONE = "America/New_York";
  var RENDER_PROBE_PARAM = "_evp_render";
  var ROOT_SELECTOR = "[data-product-availability-root]";

  if (window[GLOBAL_KEY]) {
    window[GLOBAL_KEY].initialize();
    return;
  }

  var midnightTimer = null;
  var staleRenderTimer = null;
  var staleRenderAttempts = 0;
  var staleRenderDate = null;
  var unsubscribeVariantChange = null;
  var formatter = null;

  function getFormatter() {
    if (!formatter) {
      formatter = new Intl.DateTimeFormat("en-US", {
        timeZone: TIME_ZONE,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hourCycle: "h23",
      });
    }

    return formatter;
  }

  function getZonedParts(timestamp) {
    return getFormatter()
      .formatToParts(new Date(timestamp))
      .reduce(function (parts, part) {
        if (part.type !== "literal") {
          parts[part.type] = Number(part.value);
        }
        return parts;
      }, {});
  }

  function pad(value) {
    return String(value).padStart(2, "0");
  }

  function getDateKey(parts) {
    return parts.year + "-" + pad(parts.month) + "-" + pad(parts.day);
  }

  function zonedMidnightToTimestamp(year, month, day) {
    var targetAsUtc = Date.UTC(year, month - 1, day, 0, 0, 0);
    var candidate = targetAsUtc;

    for (var iteration = 0; iteration < 4; iteration += 1) {
      var candidateParts = getZonedParts(candidate);
      var candidateAsUtc = Date.UTC(
        candidateParts.year,
        candidateParts.month - 1,
        candidateParts.day,
        candidateParts.hour,
        candidateParts.minute,
        candidateParts.second,
      );
      candidate += targetAsUtc - candidateAsUtc;
    }

    return candidate;
  }

  function nextEasternMidnight(timestamp) {
    var currentParts = getZonedParts(timestamp);
    var nextCalendarDate = new Date(
      Date.UTC(currentParts.year, currentParts.month - 1, currentParts.day + 1),
    );

    return zonedMidnightToTimestamp(
      nextCalendarDate.getUTCFullYear(),
      nextCalendarDate.getUTCMonth() + 1,
      nextCalendarDate.getUTCDate(),
    );
  }

  function getStaleRenderDelay() {
    var retryDelays = [0, 5000, 30000, 300000];
    return retryDelays[Math.min(staleRenderAttempts, retryDelays.length - 1)];
  }

  function getRenderProbeUrl() {
    var url = new URL(window.location.href);
    url.searchParams.set(RENDER_PROBE_PARAM, String(Date.now()));
    return url;
  }

  function clearRenderProbeParam() {
    var url = new URL(window.location.href);

    if (!url.searchParams.has(RENDER_PROBE_PARAM)) {
      return;
    }

    url.searchParams.delete(RENDER_PROBE_PARAM);
    window.history.replaceState(
      window.history.state,
      "",
      url.pathname + url.search + url.hash,
    );
  }

  function scheduleStaleRenderProbe(browserDate) {
    if (staleRenderDate !== browserDate) {
      staleRenderAttempts = 0;
      staleRenderDate = browserDate;
    }

    if (staleRenderTimer) {
      return;
    }

    staleRenderTimer = window.setTimeout(function () {
      staleRenderTimer = null;
      staleRenderAttempts += 1;

      var probeUrl = getRenderProbeUrl();

      window
        .fetch(probeUrl.toString(), {
          cache: "no-store",
          credentials: "same-origin",
        })
        .then(function (response) {
          if (!response.ok) {
            throw new Error("Render probe failed");
          }
          return response.text();
        })
        .then(function (responseText) {
          var responseDocument = new DOMParser().parseFromString(responseText, "text/html");
          var responseRoot = responseDocument.querySelector(ROOT_SELECTOR);
          var currentBrowserDate = getDateKey(getZonedParts(Date.now()));

          if (
            responseRoot &&
            responseRoot.dataset.renderedDate === currentBrowserDate
          ) {
            window.location.replace(probeUrl.toString());
            return;
          }

          scheduleStaleRenderProbe(currentBrowserDate);
        })
        .catch(function () {
          scheduleStaleRenderProbe(getDateKey(getZonedParts(Date.now())));
        });
    }, getStaleRenderDelay());
  }

  function refreshIfDateChanged() {
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    if (!roots.length) {
      return false;
    }

    var browserDate = getDateKey(getZonedParts(Date.now()));

    for (var index = 0; index < roots.length; index += 1) {
      var renderedDate = roots[index].dataset.renderedDate;
      if (renderedDate && renderedDate !== browserDate) {
        scheduleStaleRenderProbe(browserDate);
        return true;
      }
    }

    if (staleRenderTimer) {
      window.clearTimeout(staleRenderTimer);
      staleRenderTimer = null;
    }
    staleRenderAttempts = 0;
    staleRenderDate = null;
    clearRenderProbeParam();

    return false;
  }

  function scheduleMidnightRefresh() {
    if (midnightTimer) {
      window.clearTimeout(midnightTimer);
    }

    if (refreshIfDateChanged()) {
      return;
    }

    var delay = Math.max(1000, nextEasternMidnight(Date.now()) - Date.now() + 1000);
    midnightTimer = window.setTimeout(function () {
      if (!refreshIfDateChanged()) {
        scheduleMidnightRefresh();
      }
    }, delay);
  }

  function replaceFragment(html, sectionId, idPrefix) {
    var elementId = idPrefix + "-" + sectionId;
    var destination = document.getElementById(elementId);
    var source = html.getElementById(elementId);

    if (destination && source) {
      destination.replaceWith(source.cloneNode(true));
    }
  }

  function updateRootState(html, sectionId) {
    var destination = document.getElementById("ProductPage-" + sectionId);
    var source = html.getElementById("ProductPage-" + sectionId);

    if (!destination || !source) {
      return;
    }

    [
      "data-availability-state",
      "data-rendered-date",
      "data-release-date",
    ].forEach(function (attribute) {
      if (source.hasAttribute(attribute)) {
        destination.setAttribute(attribute, source.getAttribute(attribute));
      } else {
        destination.removeAttribute(attribute);
      }
    });
  }

  function updateVariantInput(html, sectionId) {
    var formId = "product-form-" + sectionId;
    var destinationForm = document.getElementById(formId);
    var sourceForm = html.getElementById(formId);
    var destinationInput = destinationForm && destinationForm.querySelector('[name="id"]');
    var sourceInput = sourceForm && sourceForm.querySelector('[name="id"]');

    if (!destinationInput || !sourceInput) {
      return;
    }

    destinationInput.value = sourceInput.value;
  }

  function handleVariantChange(payload) {
    if (!payload || !payload.sectionId || !payload.html) {
      return;
    }

    var sectionId = String(payload.sectionId);
    updateRootState(payload.html, sectionId);
    updateVariantInput(payload.html, sectionId);
    replaceFragment(payload.html, sectionId, "ProductTitleState");
    replaceFragment(payload.html, sectionId, "ProductPurchaseState");

    if (window.Shopify && window.Shopify.PaymentButton) {
      window.Shopify.PaymentButton.init();
    }
  }

  function subscribeToVariantChanges() {
    if (unsubscribeVariantChange) {
      return;
    }

    /*
     * pubsub.js declares `subscribe` as a global function and PUB_SUB_EVENTS
     * as a top-level `const`, so the event map is reachable only through the
     * global lexical scope, never as a window property.
     */
    if (
      typeof subscribe !== "function" ||
      typeof PUB_SUB_EVENTS === "undefined" ||
      !PUB_SUB_EVENTS.productVariantChange
    ) {
      return;
    }

    unsubscribeVariantChange = subscribe(
      PUB_SUB_EVENTS.productVariantChange,
      handleVariantChange,
    );
  }

  function initialize() {
    subscribeToVariantChanges();
    scheduleMidnightRefresh();
  }

  window[GLOBAL_KEY] = {
    initialize: initialize,
  };

  document.addEventListener("shopify:section:load", initialize);
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "visible") {
      scheduleMidnightRefresh();
    }
  });
  window.addEventListener("pageshow", scheduleMidnightRefresh);

  initialize();
})();
